var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nested-object"},[_c('submission-field',{attrs:{"submission-data":_vm.value,"flattened-fields":_vm.children}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }